import { SECTION_DESCRIPTIONS } from '@communities/community/utils/sectionDescriptions';
import { Text, Heading, Dialog } from '@soteria/design-system-ve';

import * as styles from './MoreInfoDialog.css';

interface SecurityGroupsMoreInfoDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SecurityGroupsMoreInfoDialog({ isOpen, onClose }: SecurityGroupsMoreInfoDialogProps) {
  return (
    <Dialog cancelAction={{ label: 'Close' }} isOpen={isOpen} size="xxxl" title={SECTION_DESCRIPTIONS.SECURITY_GROUPS.title} onClose={onClose}>
      <div className={styles.dialogContent}>
        <Text>
          Security groups define role-based access control for your community by mapping external authentication groups to platform roles. They determine which
          users can perform administrative, moderation, or general user actions within your community.
        </Text>

        <div className={styles.section}>
          <Heading level="h3">How Security Groups Work:</Heading>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <Text>
                <strong>Role-Based Access</strong> - Map external identity provider groups (like Active Directory groups) to platform roles
              </Text>
            </li>
            <li className={styles.listItem}>
              <Text>
                <strong>Hierarchical Permissions</strong> - Admin groups have full access, moderator groups have content management access, user groups have
                basic access
              </Text>
            </li>
            <li className={styles.listItem}>
              <Text>
                <strong>External Integration</strong> - Works with your authentication providers to validate group membership
              </Text>
            </li>
            <li className={styles.listItem}>
              <Text>
                <strong>Dynamic Authorization</strong> - User permissions are determined in real-time based on their group memberships
              </Text>
            </li>
          </ul>
        </div>

        <div className={styles.section}>
          <Heading level="h3">Role Types:</Heading>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <Text>
                <strong>Admin Groups</strong> - Full community management access including user management, configuration, and deletion
              </Text>
            </li>
            <li className={styles.listItem}>
              <Text>
                <strong>Moderator Groups</strong> - Content moderation, workflow management, and community oversight capabilities
              </Text>
            </li>
            <li className={styles.listItem}>
              <Text>
                <strong>User Groups</strong> - Basic community participation and content interaction permissions
              </Text>
            </li>
          </ul>
        </div>

        <Text>
          Security groups are essential for maintaining secure, scalable access control that integrates seamlessly with your existing identity management
          infrastructure.
        </Text>
      </div>
    </Dialog>
  );
}
